import React from "react";
const printinfocontext = React.createContext({
  selectedcopuons: "aa",
});
export default printinfocontext;
